import React, { Component } from "react";
import { getPaginatedArray } from "../utils/helpers";

class FeatureComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const page = this.props.page ? this.props.page : 1;
    console.log("param", this.props.page);
    const showSubCategoryCards = (cardData, clickEvent, page) => {
      let dataToReturn = getPaginatedArray(16, cardData[0].data, page);
      return dataToReturn.map((subCategory, index) => {
        return (
          <div
            key={index}
            className="card mid-cards"
            onClick={e => clickEvent(e, subCategory.title)}
          >
            <div className="card-header-container">
              <h6 className="categoryDescription">{subCategory.title}</h6>
            </div>
          </div>
        );
      });
    };

    return (
      <React.Fragment>
        <div className="accordion accordianBlocks">
          {showSubCategoryCards(this.props.data, this.props.onClick, page)}
        </div>
      </React.Fragment>
    );
  }
}

export default FeatureComponent;



// WEBPACK FOOTER //
// ./src/components/features/Features.js